<template>
  <b-container class="home-container container-xl">
    <b-row class="wrapper-3" cols="12">
      <b-col class="m-5 pb-2 b-1">
        <h1 class="h1-kkv">KKV Energiaköltség és Beruházás Támogatási Program 2022-2023</h1>
        <p class="p1-kkv">
          A támogatási program segítséget nyújt a feldolgozóipari és turisztikai szektorban működő vállalkozások számára
          az energiaköltségeik (villamos energia-, földgáz-, illetve távhőköltségek) támogatásában, illetve opcionálisan
          energiahatékonysági beruházáshoz kapcsolódó önerőt kiegészítő támogatás biztosításával. A program
          lebonyolítását az MGFÜ Magyar Gazdaságfejlesztési Ügynökség átvette az NFFKÜ Zrt-től.
        </p>
      </b-col>
    </b-row>
    <b-row class="b-row1-kkv-mobil">
      <button @click="toggle1" class="buttonScroll-mobil">
        <h3 class="left-span">Program leírás</h3>
        <ChevronDownIcon :size="45" :class="{ rotated: isActive1 }" />
      </button>
      <b-collapse v-model="isActive1">
        <p class="p1-kkv-mobil">
          A támogatási program segítséget nyújt a feldolgozóipari és turisztikai szektorban működő vállalkozások számára
          az energiaköltségeik (villamos energia-, földgáz-, illetve távhőköltségek) támogatásában, illetve opcionálisan
          energiahatékonysági beruházáshoz kapcsolódó önerőt kiegészítő támogatás biztosításával. A program
          lebonyolítását az MGFÜ Magyar Gazdaságfejlesztési Ügynökség átvette az NFFKÜ Zrt-től.
        </p>
      </b-collapse>
    </b-row>
    <b-container class="wrapper-4 text-left">
      <b-row class="box-top pt-5 mb-md-5">
        <b-col class="B pb-2" cols="12" lg="5">Támogatásra jogosultak köre</b-col>
        <b-col class="pb-2" cols="12" lg="7">Mikro-, kis- és középvállalkozások</b-col>
        <b-col class="B pb-2" cols="12" lg="5">Meghirdetés dátuma</b-col>
        <b-col class="pb-2" cols="12" lg="7">2022.10.01.</b-col>
        <b-col class="B pb-2" cols="12" lg="5">Igényelhető támogatás</b-col>
        <b-col class="pb-2" cols="12" lg="7">max. 500 000 euró válságtámogatásként</b-col>
        <b-col class="B pb-2" cols="12" lg="5"></b-col>
        <b-col class="pb-2" cols="12" lg="7">max. 200 000 euró de minimis támogatásként</b-col>
        <b-col class="B pb-2" cols="12" lg="5">Támogatás formája</b-col>
        <b-col class="pb-2" cols="12" lg="7">Vissza nem térítendő támogatás (VNT)</b-col>
        <b-col class="B pb-2" cols="12" lg="5"></b-col>
        <b-col class="pb-2" cols="12" lg="7">"A" komponens: teljes elszámolható nettó összköltség 50%-a</b-col>
        <b-col class="B pb-2" cols="12" lg="5"></b-col>
        <b-col class="pb-2" cols="12" lg="7">
          "B" komponens: hitellel érintett energetikai beruházás nettó összköltségének maximum 15%-a
        </b-col>
      </b-row>
      <p class="text-center">
        Támogatási kérelem beadására az "A" komponens esetében 2023.10.31-ig, a "B" komponens esetében 2024.03.31-ig
        volt lehetőség.
      </p>
    </b-container>
    <b-row class="b-row1-kkv-mobil">
      <button @click="toggle2" class="buttonScroll-mobil">
        <h3 class="left-span">Pályázati információk</h3>
        <ChevronDownIcon :size="45" :class="{ rotated: isActive2 }" />
      </button>
      <b-collapse v-model="isActive2">
        <b-row class="b-2">
          <b-col class="B pb-2" cols="12" lg="5">Támogatásra jogosultak köre</b-col>
          <b-col class="pb-2" cols="12" lg="7">Mikro-, kis- és középvállalkozások</b-col>
          <b-col class="B pb-2" cols="12" lg="5">Meghirdetés dátuma</b-col>
          <b-col class="pb-2" cols="12" lg="7">2022.10.01.</b-col>
          <b-col class="B pb-2" cols="12" lg="5">Igényelhető támogatás</b-col>
          <b-col class="pb-2" cols="12" lg="7">max. 500 000 euró válságtámogatásként</b-col>
          <b-col class="B pb-2" cols="12" lg="5"></b-col>
          <b-col class="pb-2" cols="12" lg="7">max. 200 000 euró de minimis támogatásként</b-col>
          <b-col class="B pb-2" cols="12" lg="5">Támogatás formája</b-col>
          <b-col class="pb-2" cols="12" lg="7">Vissza nem térítendő támogatás (VNT)</b-col>
          <b-col class="B pb-2" cols="12" lg="5"></b-col>
          <b-col class="pb-2" cols="12" lg="7">"A" komponens: teljes elszámolható nettó összköltség 50%-a</b-col>
          <b-col class="B pb-2" cols="12" lg="5"></b-col>
          <b-col class="pb-2" cols="12" lg="7">
            "B" komponens: hitellel érintett energetikai beruházás nettó összköltségének maximum 15%-a
          </b-col>
        </b-row>
        <p class="text-center">
          Támogatási kérelem beadására az "A" komponens esetében 2023.10.31-ig, a "B" komponens esetében 2024.03.31-ig
          volt lehetőség.
        </p>
      </b-collapse>
    </b-row>
    <b-row class="pt-4">
      <b-col class="Box_padding" cols="12" lg="6">
        <div>
          <b-row class="pt-1">
            <b-col class="ml-4 wrapper-5 p-5">
              <img style="padding-bottom: 20px" src="../assets/img/icons/Vector_nyertes_palyazat.svg" />
              <p class="whiteText">> 3 300 db</p>
              <p class="whiteText">Nyertes pályázat</p>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col class="Box_padding" cols="12" lg="6">
        <div>
          <b-row class="pt-1">
            <b-col class="ml-4 wrapper-5 p-5">
              <img style="padding-bottom: 20px" src="../assets/img/icons/Vector_kifizetett_tamogatas.svg" />
              <p class="whiteText">> 21,5 Mrd Ft</p>
              <p class="whiteText">Kifizetett támogatás</p>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <b-container>
      <h2 class="font-weight-bold pb-4 pt-4">
        Támogatott projektek
      </h2>
      <b-row>
        <b-col class="Box_padding" cols="12" lg="6">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper-2 p-4">
                <a
                  class="services-button-wrapper-2"
                  download
                  target="_blank"
                  href="https://vali.hu/static/Energiapalyazat_tamogatottvallalkozasok_A.pdf"
                >
                  <p class="greenText mb-1 pt-4">Támogatott vállalkozások listája A komponens</p>
                  <img style="padding-bottom: 20px" src="../assets/img/icons/download.svg" />
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col class="Box_padding" cols="12" lg="6">
          <div>
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper-2 p-4">
                <a
                  class="services-button-wrapper-2"
                  download
                  target="_blank"
                  href="https://vali.hu/static/Energiapalyazat_tamogatottvallalkozasok_B.pdf"
                >
                  <p class="greenText mb-1 pt-4">Támogatott vállalkozások listája B komponens</p>
                  <img style="padding-bottom: 20px" src="../assets/img/icons/download.svg" />
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <h2 class="mb-4 pt-5">A komponens szakmai beszámoló benyújtása</h2>
    <div class="b-3">
      <img src="../assets/img/elsobek.svg" alt="SVG Image" />
    </div>
    <b-row class="b-3-mobil">
      <button @click="toggle3" class="buttonScroll-mobil">
        <h3 class="left-span mt-4 mb-4">Pályázás ütemezése</h3>
        <ChevronDownIcon :size="45" :class="{ rotated: isActive3 }" />
      </button>
      <b-collapse class="mobilcsollapse" v-model="isActive3">
        <div>
          <img src="../assets/img/mobilelsobek.svg" alt="SVG Image" />
        </div>
      </b-collapse>
    </b-row>
    <b-container>
      <b-row class="mt-2 pt-3">
        <b-button
          class="bigButton"
          @click="openLink('https://energiatamogatas.vali.hu/feldolgozoipar/kau-login')"
          target="_blank"
        >
          <h2 class="greenH">
            <span class="left-span">Beszámoló benyújtása - Feldolgozó ipar</span>
            <ChevronRightIcon :size="45" class="text-right" />
          </h2>
        </b-button>
      </b-row>
      <b-row class="mt-2 pt-3">
        <b-button
          class="bigButton"
          @click="openLink('https://energiatamogatas.vali.hu/szallas/kau-login')"
          target="_blank"
        >
          <h2 class="greenH">
            <span class="left-span">Beszámoló benyújtása - Szálláshely/Vendéglátás</span>
            <ChevronRightIcon :size="45" class="text-right" />
          </h2>
        </b-button>
      </b-row>
    </b-container>
    <h2 class="mb-4 mt-5">B komponens fenntartási jelentés benyújtása</h2>
    <div class="b-4">
      <img src="../assets/img/masodikbek.svg" alt="SVG Image" />
    </div>
    <b-row class="b-4-mobil m-1">
      <button @click="toggle4" class="buttonScroll-mobil">
        <h3 class="left-span mt-4 mb-4">Pályázás ütemezése</h3>
        <ChevronDownIcon :size="45" :class="{ rotated: isActive4 }" />
      </button>
      <b-collapse class="mobilcsollapse" v-model="isActive4">
        <div>
          <img src="../assets/img/mobilmasodikbek.svg" alt="SVG Image" />
        </div>
      </b-collapse>
    </b-row>
    <b-row>
      <b-col>
        <div class="documents-section">
          <button v-b-toggle.accordion-docs-first @click="toggleIsActiveFirst" class="buttonScroll">
            <h3 class="left-span">Pályázati dokumentumok</h3>
            <span :style="{ transform: isActive ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }">
              <ChevronRightIcon :size="45" />
            </span>
          </button>
          <b-collapse id="accordion-docs-first" v-model="isActive" class="mt-3">
            <div class="download greenText">
              <ul class="p-1">
                <li v-for="doc in accordionItemsFirst[0].documents" :key="doc.text">
                  <a class="services-button-wrapper" download target="_blank" :href="doc.url">
                    {{ doc.text }}
                    <img src="../assets/img/icons/download.svg" />
                  </a>
                </li>
              </ul>
            </div>
          </b-collapse>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="documents-section">
          <button v-b-toggle.accordion-docs-second @click="toggleIsActiveSecond" class="buttonScroll">
            <h3 class="left-span">Pályázati dokumentumok archív</h3>
            <span :style="{ transform: isActive ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }">
              <ChevronRightIcon :size="45" />
            </span>
          </button>
          <b-collapse id="accordion-docs-second" v-model="isActive" class="mt-3">
            <div class="download greenText">
              <ul class="p-1">
                <li v-for="doc in accordionItemsSecond[0].documents" :key="doc.text">
                  <a class="services-button-wrapper" download target="_blank" :href="doc.url">
                    {{ doc.text }}
                    <img src="../assets/img/icons/download.svg" />
                  </a>
                </li>
              </ul>
            </div>
          </b-collapse>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-button class="bigButton mt-1" @click="openLink('/fund-map')" target="_blank">
        <h2 class="greenH">
          <img src="../assets/img/icons/tovabbi_palyazat.svg" class="icon-left" />
          <span class="left-span-2">További pályázati lehetőségek</span>
          <ChevronRightIcon :size="45" class="text-right" />
        </h2>
      </b-button>
    </b-row>

    <b-container>
      <h2 class="font-weight-bold mb-5 mt-5">
        Ügyfélszolgálat elérhetősége
      </h2>
      <b-row>
        <b-col class="Box_padding" cols="12" lg="6">
          <div class="text-left">
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-4">
                <p class="greenText-small-text pt-3 mb-2">
                  Ügyfélszolgálat várja megkeresését az alábbi munkarendben:
                </p>
                <p class="mb-2">Hétfőtől csütörtökig: 8:00 – 17:00</p>
                <p>Pénteken: 8:00 – 14:30</p>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col class="Box_padding" cols="12" lg="6">
          <div class="text-left">
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-4">
                <p class="greenText pt-3 mb-2">Ügyfélszolgálat elérhetősége:</p>
                <p class="mb-2"><img class="mr-2" src="../assets/img/icons/homephone.svg" /> +36 1 312 2213</p>
                <p>
                  <img class="mr-2" src="../assets/img/icons/envelope.svg" />
                  <a href="mailto:info@mgfu.hu">
                    info@mgfu.hu
                  </a>
                </p>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-row>
      <b-col>
        <p class="text-left mt-5">
          A program forrását Magyarország Kormánya által nyújtott támogatás mellett a
          <strong> KEHOP-7.1.1-23-2023-00001 azonosítószámú</strong>, Energiaintenzív kkv-k támogatása című kiemelt
          projekt biztosítja.
          <br />
          <br />
          A kedvezményezett neve: Magyar Gazdaságfejlesztési Ügynökség Közhasznú Nonprofit Kft.
          <br />
          <strong>
            A projekt címe: Energiaintenzív kkv-k támogatása
          </strong>
          <br />
          <strong> A projekt azonosító száma: KEHOP-7.1.1-23-2023-00001</strong>
          <br />
          A projekt tervezett befejezési dátuma: 2023. 12. 31.
          <br />
          A szerződött támogatás összege: 12 489 138 652 Ft
          <br />
          A támogatás mértéke (%-ban): 100%
        </p>
      </b-col>
    </b-row>
    <DemjanSandorProgram />
  </b-container>
</template>

<script>
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import DemjanSandorProgram from './DemjanSandorProgram.vue'
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'

export default {
  components: {
    ChevronRightIcon,
    DemjanSandorProgram,
    ChevronDownIcon
  },
  data() {
    return {
      isActiveFirst: false,
      isActiveSecond: false,
      accordionItemsFirst: [
        {
          documents: [
            {
              text: 'Pályázati felhívás',
              url: 'https://vali.hu/static/Felhivas_mod_KKV_Energiakoltseg_Tamogatasi_Program.pdf'
            },
            {
              text: 'Szakmai beszámoló kitöltési segédlet',
              url: 'https://vali.hu/static/Szakmai_beszamolo-palyazoi_kitoltesi_segedlet.pdf'
            },
            {
              text: 'Fenntartási jelentés kitöltési segédlet ',
              url: ''
            },
            {
              text: 'Foglalkoztatotti létszám segédlet',
              url: 'https://vali.hu/static/Foglalkoztatotti_letszam_segedlet.pdf'
            }
          ]
        }
      ],
      accordionItemsSecond: [
        {
          documents: [
            {
              text: 'Pályázati felhívás (archív)',
              url: 'https://vali.hu/static/Felhivas_mod_KKV_Energiakoltseg_Tamogatasi_Program_archiv.pdf'
            },
            {
              text: 'Kitöltési útmutató - szálláshely, vendéglátás',
              url: 'https://vali.hu/static/palyazati_felulet-kitoltesi_utmutato_feldolgozoipar.pdf'
            },
            {
              text: '“A” Pályázás menete - szálláshely, vendéglátás',
              url: 'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_palyazas_menete_A_szalloda_vendeglatas.pdf'
            },
            {
              text: '“A” Pályázás menete - feldolgozóipar',
              url: 'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_palyazas_menete_A_feldolgozo-ipar.pdf'
            },
            {
              text: '“B” Pályázás menet - szállás',
              url: 'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_palyazas_menete_B_szalloda_vendeglatas.pdf'
            },
            {
              text: '“B” Pályázás menete - feldolgozóipar',
              url: 'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_palyazas_menete_B_feldolgozo-ipar.pdf'
            },
            {
              text: '“A” Költségtámogatás ismertető - szállás',
              url:
                'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_A_koltsegtamogatas_ismerteto_szalloda_vendeglatas.pdf'
            },
            {
              text: '“A” Költségtámogatás ismertető - feldolgozóipar',
              url:
                'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_A_koltsegtamogatas_ismerteto_feldolg_ipar.pdf'
            },
            {
              text: '“B” Önerő támogatás ismertető - szállás',
              url:
                'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_B_onero_tamogatas_ismerteto_szalloda_vendeglatas.pdf'
            },
            {
              text: '“B” Önerő támogatás ismertető - feldolgozóipar',
              url:
                'https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_B_onero_tamogatas_ismerteto_feldolgozo-ipar.pdf'
            },
            {
              text: 'GYIK -szálláshely, vendéglátás',
              url: 'https://vali.hu/static/GYIK_Szallashely_vendeglatas.pdf'
            },
            {
              text: 'GYIK – feldolgozóipar',
              url: 'https://vali.hu/static/GYIK_Feldolgozoipari.pdf'
            },
            {
              text: 'Egyéni vállalkozó nyilatkozata',
              url: 'https://vali.hu/static/Egyeni_vallalkozo_nyilatkozata_MGFU.docx'
            },
            {
              text: 'Jogi személy nyilatkozata',
              url: 'https://vali.hu/static/Jogi_szemely_nyilatkozata_MGFU.docx'
            },
            {
              text: 'Összeférhetetlenségi nyilatkozat',
              url: 'https://vali.hu/static/osszeferhetetlensegi_nyilatkozat_MGFU.xlsx'
            },
            {
              text: 'Bankszámlaszámokról szóló nyilatkozat',
              url: 'https://vali.hu/static/Bankszamlaszamokrol_szolo_nyilatkozat_MGFU.docx'
            },
            {
              text: 'Meghatalmazás',
              url: 'https://vali.hu/static/Meghatalmazas_MGFU.docx'
            },
            {
              text: 'Felhatalmazó levél',
              url: 'https://vali.hu/static/Energiatamogatas_Felhat_level_sablon_MGFU.docx'
            }
          ]
        }
      ],
      isActive1: this.value,
      isActive2: this.value,
      isActive3: this.value,
      isActive4: this.value
    }
  },
  methods: {
    toggleIsActiveFirst() {
      this.isActiveFirst = !this.isActiveFirst
    },
    toggleIsActiveSecond() {
      this.isActiveSecond = !this.isActiveSecond
    },
    openLink(url) {
      window.open(url, '_blank')
    },
    toggle1() {
      this.isActive1 = !this.isActive1
    },
    toggle2() {
      this.isActive2 = !this.isActive2
    },
    toggle3() {
      this.isActive3 = !this.isActive3
    },
    toggle4() {
      this.isActive4 = !this.isActive4
    }
  }
}
</script>

<style scoped>
.rotated {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.chevron-icon {
  transition: transform 0.3s ease;
}

.chevron-rotate {
  transform: rotate(90deg); /* Elforgatás 90 fokkal (balra mutató nyíl) */
}

.download ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.Box_padding {
  padding-left: 0 !important;
  padding-right: 19px !important;
  margin-top: 0px;
  margin-bottom: 10px;
}

.greenText {
  color: #00903c;
  font-weight: bold;
  font-size: large;
}

.greenText-small-text {
  color: #00903c;
  font-weight: bold;
  font-size: 17px;
}

.wrapper {
  background: #f2f8fa;
  border-radius: 12px;
}

.wrapper-2 {
  background: #f2f8fa;
  border-radius: 12px;
  text-align: center;
}

.services-wrapper {
  background: #f2f8fa;
  padding: 24px;
  padding-top: 32px;
  padding-bottom: 32px;
}
.services-bottom-wrapper {
  background: #f2f8fa;
  padding: 24px;
  padding-top: 24px;
  padding-bottom: 0px;
}

.text-right {
  position: absolute;
  right: 35px; /* Az ikon mindig ugyanott marad a gomb jobb oldalán */
  top: 50%;
  transform: translateY(-50%); /* Középre igazítás vertikálisan */
}

.icon-left {
  width: 35px;
  height: auto;
  position: absolute;
  left: 230px;
}

.wrapper-3 {
  color: black;
  border-radius: 10px 10px 0px 0px;
  background-image: url('../assets/img/unsplash_background.svg');
  margin-left: 0px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.h1-kkv {
  text-align: left;
  color: #00903c;
}

.p1-kkv {
  font-size: 16px;
  text-align: justify;
  margin: 0 auto;
}

.box-top {
  font-size: large;
  margin-left: 60px;
}

.wrapper-4 {
  background: #f2f8fa;
  border-radius: 0px 0px 12px 12px;
  margin-left: 0px;
  display: block;
}

.B {
  font-weight: bold;
}

.bigButton {
  width: 100%;
  height: 120px;
  background: #00903c !important;
  font-weight: 700;
  color: white;
  line-height: 32px;
  border-radius: 8px;
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative; /* Ehhez képest pozicionáljuk az ikont */
}

.bigButton:focus,
.bigButton:focus-visible,
.bigButton:active {
  outline: none !important;
  box-shadow: none !important;
  border: none;
}

.greenH {
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #00903c !important;
  color: #fff;
  border-radius: 10px;
  padding-right: 60px; /* Hagyjunk helyet az ikon számára */
  text-align: center;
}

.wrapper-5 {
  background: #00903c;
  border-radius: 5px;
  text-align: center;
}

.whiteText {
  color: white;
  font-weight: bold;
  font-size: 32px;
}

.left-span {
  text-align: center; /* A bal oldali span középre igazítása */
  flex-grow: 1; /* Ezzel biztosítjuk, hogy a bal oldali span középen maradjon */
}

.left-span-2 {
  text-align: center; /* A bal oldali span középre igazítása */
  flex-grow: 1; /* Ezzel biztosítjuk, hogy a bal oldali span középen maradjon */
  margin-left: 30px;
}

.buttonScroll:focus,
.buttonScroll:focus-visible,
.buttonScroll:active {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

.buttonScroll:hover {
  background-color: #e5f0f5 !important;
}

.buttonRight {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.DownloadSroll {
  font-size: larger;
  border-radius: 12px;
  border: black;
  height: 160px;
  background-color: #f2f8fa;
}

.left-span {
  text-align: center; /* A bal oldali span középre igazítása */
  flex-grow: 1; /* Ezzel biztosítjuk, hogy a bal oldali span középen maradjon */
  font-weight: bold;
}

.Box_padding {
  padding-left: 0 !important;
  padding-right: 19px !important;
}

.when-opened svg,
.when-closed svg {
  fill: var(--color-green);
  cursor: pointer;
  margin-top: 0px;
  transition: opacity 1s ease-out;
}

.when-opened svg,
.when-closed svg {
  fill: var(--color-green);
  cursor: pointer;
  margin-top: -10px;
  transition: opacity 1s ease-out;
}

.full-width-info {
  position: relative;
  width: 60%;
  background-color: #f9f9f9;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 15px;
  font-size: 18px;
  line-height: 1.6;
}

.b-row1-kkv-mobil {
  display: none;
}

.b-3,
.b-4 {
  display: block;
}
.b-3-mobil,
.b-4-mobil {
  display: none;
}

/* Csak a mobil képernyőkön (max-width: 767px) történő viselkedés */
@media (max-width: 767px) {
  .wrapper-4 {
    display: none;
  }

  .Box_padding {
    padding-left: 10px !important;
  }

  .buttonScroll-mobil {
    width: 95%;
    padding: 0 18px;
    margin: 0 12px;
    background-color: #c3d9cc !important;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: larger;
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
  }

  .left-span {
    font-size: 25px;
  }

  .h1-kkv {
    font-size: 32px;
    margin-top: 10px;
    color: black !important;
  }
  .p1-kkv {
    display: none;
  }
  .b-1 {
    margin: 22px !important;
  }
  .b-2 {
    margin: 22px !important;
    background-color: #c3d9cc !important;
  }
  .b-row1-kkv-mobil {
    display: block;
    background-color: #c3d9cc !important;
    border-radius: 12px;
    margin: 8px;
    padding: 22px;
    text-align: justify;
  }
  .p1-kkv-mobil {
    margin: 22px;
  }
  .b-3,
  .b-4 {
    display: none;
  }
  .b-3-mobil,
  .b-4-mobil {
    display: block;
  }
  .mobilcsollapse img {
    width: 100%;
    height: auto; /* Ez megtartja az arányokat */
  }
  .icon-left {
    left: 20px;
  }
}

.buttonScroll {
  width: 100%;
  height: 160px;
  padding: 15px 20px;
  background-color: #f2f8fa !important;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: larger;
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

.documents-section {
  margin: 20px 0;
}

.services-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  width: 100%;
  text-decoration: none;
  color: inherit;
}
.services-button-wrapper-2 {
  display: block;
  text-decoration: none;
  color: inherit;
}
</style>
